export const TOTAL_LENGTH_OF_LONG_LIST = 41;

export const HOURS = Array.from({ length: 24 }, (_, index) => index);
export const MINUTES = Array.from({ length: 60 }, (_, index) => index);
